module.exports = __webpack_public_path__ + "static/img/200312.60ae3092.png";